module.exports = __webpack_public_path__ + "img/chick_placement.decb5b76.svg";